import {connect} from "react-redux";
import {selectUserId} from "../../../redux/selectors/editor";
import {selectUser} from "../../../redux/selectors/firebase";
import {Box, Button, Dialog, DialogContent, DialogTitle, TextField, Typography} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {ChangeEventHandler, FocusEventHandler, useContext, useState} from "react";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {
    getAuth,
    linkWithCredential,
    EmailAuthProvider,
    GoogleAuthProvider,
    reauthenticateWithPopup
} from "firebase/auth";

const useStyles = makeStyles((theme) => ({
    content: {
        marginRight: theme.spacing(1),
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    }
}));

interface IUser {
    email: string
    initialised: number
    name: string
}
interface IProps {
    onClose: () => any
    user: IUser
    userKey: string
}
function UserDialog({onClose, user, userKey}: IProps) {
    const classes = useStyles();
    const [password, setPassword] = useState("");
    const {set} = useContext(FirebaseContext);
    const handleNameBlur: FocusEventHandler<HTMLInputElement> = ({target}) =>
        set(`users/${userKey}/name`, target.value);
    const handleNameEmail: FocusEventHandler<HTMLInputElement> = ({target}) =>
        set(`users/${userKey}/email`, target.value);
    const handlePasswordChange: ChangeEventHandler<HTMLInputElement> = ({target}) =>
        setPassword(target.value);
    const handleAddPasswordClick = () => {
        if (auth.currentUser && user.email) {
            reauthenticateWithPopup(auth.currentUser, new GoogleAuthProvider()).then((authenticated) => {
                const credential = EmailAuthProvider.credential(user.email, password);

                linkWithCredential(authenticated.user, credential).then(() => setPassword(""));
            });
        }
    }
    const auth = getAuth();
    const providers = auth.currentUser?.providerData || [];
    const googleProvider = providers.find(provider => provider.providerId === "google.com");
    const passwordProvider = providers.find(provider => provider.providerId === "password");

    return (
        <Dialog fullWidth open={true} onClose={onClose}>
            <DialogTitle>User Details</DialogTitle>
            <DialogContent className={classes.content}>
                <Box>
                    <TextField label="Display Name" defaultValue={user.name} fullWidth
                               onBlur={handleNameBlur} size="small" sx={{m:1}}/>
                    <TextField label="Email" defaultValue={user.email} fullWidth
                               onBlur={handleNameEmail} size="small" sx={{m:1}}/>
                </Box>
                {googleProvider && ! passwordProvider &&
                    <Box>
                        <Typography variant="body1" sx={{m:1}}>
                            You have registered a Google account but will need a password to connect the TouchVideo editor
                        </Typography>
                        <Box display="flex">
                            <TextField label="Password" defaultValue={password} fullWidth
                                       onChange={handlePasswordChange} size="small" sx={{m:1}} type="password"/>
                            <Button disabled={password.length < 8} onClick={handleAddPasswordClick}
                                    sx={{m:1}} variant="contained">Update</Button>
                        </Box>
                    </Box>}
            </DialogContent>
        </Dialog>
    );
}
const mapStateToProps = (store: never) => ({
    user: selectUser(store),
    userKey: selectUserId(store),
});

export default connect(mapStateToProps, {
})(UserDialog);

